export const vscode = window.vscode = window.acquireVsCodeApi?.();